import { IconButton } from '@ui';
import { useSyncExternalStore } from 'react';
import { ShieldIcon } from './icons';
import { onScreenMask, screenMaskDefaultOn, screenMaskOffered, shotShieldOn, toggleShotShield } from './screenMask';

/*
 * The shield of the shots (report 106; report 190, decision of 31.10; report 303 — Quint report_window Ок5, report_tools Ок6, Ок7):
 * one icon button in the tools row of the report window, of the same kind as the camera and the area next to it. It covers
 * the shots, not the page around the panel: the page is covered by the help menu and Alt+Shift+M (screen_mask). Until it is
 * pressed it follows the screen mode; the shot hides the marked names always, except where the host gave the switch
 * (`dialog.maskSwitch`, facts to its admins) and the shield is off: the shot is then taken as the page is (report 101, Quint
 * shot_shield Щт1). The label and the tooltip say what is covered and what stays open; the state is the colour of the icon.
 */
export const SHIELD_ON = 'Данные людей на снимках скрыты';
export const SHIELD_OFF = 'Данные людей на снимках видны';
const COVERED = 'ФИО, ники, Telegram ID, телефоны, заметки и переписка';
const OPEN = 'заголовки, кнопки и счётчики';

/** What the shield tells in its tooltip: what is covered on a shot, what stays open, and that the page itself is not touched. */
export const shieldHint = (on: boolean, offOpensShots = false): string =>
  on
    ? `${SHIELD_ON}: закрыты ${COVERED}. Открыты ${OPEN}. Страница вокруг панели не меняется. Нажмите, чтобы показывать на снимках`
    : `${SHIELD_OFF}. Нажмите, чтобы закрыть ${COVERED}; ${OPEN} останутся открытыми. Страница вокруг панели не меняется. ${
        offOpensShots ? 'Снимки сейчас без закрашивания' : 'Помеченные данные на снимках закрыты всегда'
      }`;

export default function ScreenMaskBeacon({ className = '', offOpensShots = false }: { className?: string; offOpensShots?: boolean }) {
  const on = useSyncExternalStore(onScreenMask, shotShieldOn);
  // The offer comes with `configure()`: the overlay re-renders on every call, so a plain read is current.
  if (!screenMaskOffered()) return null;
  // Off where the host wants it on at every load (`'default-on'`) is a warning: red, not the gold of a plain choice.
  const tone = on ? ' bug-beacon-on' : screenMaskDefaultOn() ? ' bug-beacon-alert' : '';
  return (
    <span className={`bug-beacon${tone}${className ? ` ${className}` : ''}`}>
      <IconButton label={on ? SHIELD_ON : SHIELD_OFF} title={shieldHint(on, offOpensShots)} icon={<ShieldIcon />} pressed={on} onClick={toggleShotShield} />
    </span>
  );
}
